<template>
    <train-list></train-list>
</template>
<style>

</style>
<script>
    import trainListpage from "trainListpage";
    export default{
        data(){
            return{

            }
        },
        components:{

        }
    }
</script>



// WEBPACK FOOTER //
// src/views/train/trainList/trainList.vue